import React from 'react';

function CoursesFooter() {
  return (
    <footer>
      <h4>I'm footer. Override me🏇</h4>
    </footer>
  );
}

export default CoursesFooter;
